import { useQuestionnaireReportSearchParams } from '../use-questionnaire-report-search-params';

/**
 * Returns true when every questionnaire report filter has a value —
 * both dates picked and at least one Exam Center + Exam Course selected.
 * Used to gate the report body and the export button until the user has
 * applied a full filter set.
 */
export function useIsQuestionnaireReportFilterApplied(): boolean {
  const [{ examStartDate, examEndDate, examCenter, examCourse }] =
    useQuestionnaireReportSearchParams();

  return (
    examStartDate !== null && examEndDate !== null && examCenter.length > 0 && examCourse.length > 0
  );
}
